/* rise-footer-patch.js */
(function () {
	'use strict';

	function patch() {
		// cart-items のクラス定義を Custom Elements から取得（Riseでも確実）
		const Ctor = customElements.get('cart-items');
		if (!Ctor || !Ctor.prototype) return false;

		// 1) 置換対象セレクタを .js-contents → .totals に変更
		const origGet = Ctor.prototype.getSectionsToRender;
		Ctor.prototype.getSectionsToRender = function () {
			const list = origGet.call(this);
			const footer = list && list.find(s => s.id === 'main-cart-footer');
			if (footer) {
				// あなたのマークアップに必ず存在する親要素に合わせる
				// 例: <div class="totals"> ... <p class="totals__total-value"> ... </p>
				footer.selector = '.totals__total-value';
			}
			return list;
		};

		// 2) 返却HTML側に .totals が無い場合でも落ちないフォールバック
		const origGetHTML = Ctor.prototype.getSectionInnerHTML;
		Ctor.prototype.getSectionInnerHTML = function (html, selector) {
			const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
			let node = selector ? doc.querySelector(selector) : null;
			// フォールバック順: .totals → #main-cart-footer → <body>
			node = node || doc.querySelector('.totals') || doc.querySelector('#main-cart-footer') || doc.body;
			return node.innerHTML;
		};

		console.log('[rise-footer-patch] applied');
		return true;
	}

	// Custom Element が登録されるまで待つ
	(function wait(i = 0) {
		if (patch()) return;
		if (i > 200) return; // ~10秒で諦め
		setTimeout(() => wait(i + 1), 50);
	})();
})();
